import * as React from "react";

import { Maybe } from "../../types/thecookies";

export const getSocialMetaTag = (url: string, img: string, title: Maybe<string>, description: Maybe<string>) => {
  if (url.includes("facebook.com")) {
    return <meta property="fb:app_id" content={url} />;
  } else if (url.includes("twitter.com")) {
    return (
      <>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:creator" content={url} />
        <meta name="twitter:site" content={url} />
        <meta name="twitter:title" content={`${title}`} />
        <meta name="twitter:description" content={`${description}`} />
        <meta name="twitter:image:src" content={img} />
      </>
    );
  } else {
    return <> </>;
  }
};
